import InterviewNotesManager from './InterviewNotesManager.container';

export default InterviewNotesManager;
